// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetPromoCodeRemovePackageResponse

export type WidgetPromoCodeRemovePackageApiResponse = {
	success: boolean;
	amount: number | null;
};

export type WidgetPromoCodeRemovePackage = {
	success: boolean;
	amount: number | null;
};

export function hydrateWidgetPromoCodeRemovePackage(data: WidgetPromoCodeRemovePackageApiResponse): WidgetPromoCodeRemovePackage {
	return { ...data };
}